import { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { Hand, Crosshair, Undo2, Check, X, ArrowLeftRight } from 'lucide-react';
import { useGlove, setGlove, buzz, toolsLeft, flipHand } from '../lib/glove';

export const GloveBtn = ({ t, testid = 'glove-btn' }) => {
  const g = useGlove();
  const toggle = () => { setGlove({ on: !g.on }); toast.success(g.on ? t.glOff : t.glOn); if (!g.on) navigator.vibrate?.(60); };
  return (
    <button className={`chip help-chip glove-chip ${g.on ? 'on-chip' : ''}`} data-testid={testid} aria-pressed={g.on} onClick={toggle} title={t.glTitle}>
      <Hand size={15} /> <span>{t.glBtn}</span>
    </button>
  );
};

// one-hand thumb bar while drawing a pipe or placing fittings
export function ThumbBar({ t, net }) {
  const g = useGlove();
  const d = net.draft;
  const n = d?.points?.length || 0, prev = useRef(n), fit = useRef(net.lastFit);
  useEffect(() => { if (n > prev.current) buzz(45); prev.current = n; }, [n]);
  useEffect(() => { if (net.lastFit && net.lastFit !== fit.current) buzz(45); fit.current = net.lastFit; }, [net.lastFit]);
  if (!g.on || !d || (d.kind !== 'pipe' && d.kind !== 'fitting')) return null;
  const isPipe = d.kind === 'pipe';
  return (
    <div className={`thumb-bar mask ${toolsLeft(g) ? 'is-left' : ''}`} data-testid="thumb-bar">
      <div className="tb-side">
        <button className="tb-mini" data-testid="thumb-hand-btn" onClick={flipHand} title={t.glHand}><ArrowLeftRight size={18} /></button>
        <button className="tb-mini danger" data-testid="thumb-cancel-btn" onClick={() => { buzz([30, 40, 30]); net.cancelDraft(); }}><X size={20} /></button>
      </div>
      {isPipe && <button className="tb-btn" data-testid="thumb-undo-btn" disabled={!n} onClick={() => { buzz(25); net.setDraft({ ...d, points: d.points.slice(0, -1) }); }}><Undo2 size={26} /><span>{t.btnUndo}</span></button>}
      <button className="tb-btn tb-done" data-testid="thumb-finish-btn" disabled={isPipe && n < 2} onClick={() => { buzz([60, 50, 120]); isPipe ? net.finishPipe() : net.setDraft(null); }}><Check size={28} /><span>{isPipe ? t.btnFinish : t.btnDone}</span></button>
      <button className="tb-btn tb-main" data-testid="thumb-point-btn" onClick={net.addAtCrosshair}><Crosshair size={34} /><span>{isPipe ? `${t.glPoint} (${n})` : t.plcCross}</span></button>
    </div>
  );
}
